/// <reference path="jquery.js"/>
/*
* dragndrop
* version: 1.0.0 (05/13/2009)
* @ jQuery v1.2.*
*
* Licensed under the GPL:
*   http://gplv3.fsf.org
*
* Copyright 2008, 2009 Jericho [ thisnamemeansnothing[at]gmail.com ]
*  usage:
*
*/
(function($) {
    $.extend($.fn,
    {
        getCss: function(key)
        {
            var v = parseInt(this.css(key));
            if (isNaN(v))
                return false;
            return v;
        }
    });
    $.fn.Drags = function(opts)
    {
        var ps = $.extend(
        {
            ////zIndex: 20,
            //opacity: 1,//.7,
            handler: null,
            onMove: function() { },
            onDrop: function() { }
        }, opts);
        var dragndrop =
        {
            drag: function(e)
            {
                //console.log("drag!");
                var dragData = e.data.dragData;
                //console.log("offset l:"+dragData.left+"; e.pageX:"+e.pageX+"; dragData.offLeft:"+dragData.offLeft);
                //console.log("offset t:"+dragData.top+"; e.pageY:"+e.pageY+"; dragData.offTop:"+dragData.offTop);
                dragData.target.css(
                {
                    position: 'absolute',
                    left: dragData.left + e.pageX /**** + $('body').scrollLeft()/***/ - dragData.offLeft,
                    top: dragData.top + e.pageY /**** + $('body').scrollTop()/***/ - dragData.offTop
                });
                //console.dir({x:e.pageX,y:e.pageY, offset:dragData.target.offset()});
                //console.log($('body').scrollTop());
                //dragData.handler.css({ cursor: 'move' });
                dragData.onMove(e);
            },
            drop: function(e)
            {
                var dragData = e.data.dragData;
                //dragData.target.css(dragData.oldCss).removeClass("moving"); //.css({ 'opacity': '' });
                //dragData.handler.css('cursor', dragData.oldCss.cursor);
                dragData.onDrop(e);
                $(document).unbind('mousemove', dragndrop.drag)
                    .unbind('mouseup', dragndrop.drop);

                // To prevent Chrome change cursor to text — return back
                document.onselectstart = function(){ return true; }
            }
        }
        return this.each(function() {
            var me = this;
            var handler = null;
            if (typeof ps.handler == 'undefined' || ps.handler == null)
                handler = $(me);
            else
                handler = (typeof ps.handler == 'string' ? $(ps.handler, this) : ps.handle);
            handler.bind('mousedown', { e: me }, function(s)
            {
                //console.log("handler mousedown 333");
                var target = $(s.data.e);
                var oldCss = {};

                //oldCss.cursor = target.css('cursor') || 'default';
                //oldCss.opacity = target.getCss('opacity') || 1;
                var offset = target.offset();
                /***
                target
                    .css({margin: 0, left:offset.left, top:offset.top});
                **/
                    //.addClass("moving");
                //console.log("offset l:"+offset.left+"; t:"+offset.top);
                var dragData =
                {
                    left: offset.left, //-$('body').scrollLeft(),//oldCss.left || target.getCss('left') || 0,
                    top: target.getCss('top'), // offset.top ||-$('body').scrollTop() || oldCss.top || target.getCss('top') || 0,
                    width: target.width() || target.getCss('width'),
                    height: target.height() || target.getCss('height'),
                    offLeft: s.pageX /**** + $('body').scrollLeft()/***/,
                    offTop: s.pageY /**** + $('body').scrollTop()/***/,
                    oldCss: oldCss,
                    onMove: ps.onMove,
                    onDrop: ps.onDrop,
                    handler: handler,
                    target: target
                }
                //console.dir(dragData);
                //target.css('opacity', ps.opacity);
                // To prevent Chrome change cursor to text
                document.onselectstart = function(){ return false; }
                $(document)
                    .bind('mousemove', { dragData: dragData }, dragndrop.drag)
                    .bind('mouseup', { dragData: dragData }, dragndrop.drop);
            });
        });
    }
})(jQuery);
